import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
class Calculator extends Component {
    constructor(props) {
        super(props);
        this.onChangebCalculator = this.onChangebCalculator.bind(this);
        this.onChangebCurrentPrice = this.onChangebCurrentPrice.bind(this);
        this.onChangebCommission = this.onChangebCommission.bind(this);
        this.onChangebQuantity = this.onChangebQuantity.bind(this);
        this.onChangesCalculator = this.onChangesCalculator.bind(this);
        this.onChangesCurrentPrice = this.onChangesCurrentPrice.bind(this);
        this.onChangesCommission = this.onChangesCommission.bind(this);
        this.onChangesQuantity = this.onChangesQuantity.bind(this);

        this.state = {
            bcurrentprice: 0,
            bquantity: 0,
            bcommission: 1.725,
            btotal_cost: 0,
            scurrentprice: 0,
            squantity: 0,
            scommission: 2.025,
            stotal_cost: 0,
        }
    }

    onChangebCurrentPrice(e) {
        this.setState({
            bcurrentprice: e.target.value
        })

        this.onChangebCalculator();
    }

    onChangebCommission(e) {
        this.setState({
            bcommission: e.target.value
        })
        this.onChangebCalculator();
    }

    onChangebQuantity(e) {
        this.setState({
            bquantity: e.target.value
        })
        this.onChangebCalculator();
    }

    onChangebCalculator() {
        setTimeout(() => {
            let comm = parseFloat(this.state.bcommission ? this.state.bcommission : 0) / 100,
                cp = parseFloat(this.state.bcurrentprice ? this.state.bcurrentprice : 0),
                qty = parseFloat(this.state.bquantity ? this.state.bquantity : 0);
            let tcp = cp * qty;
            let tcom = tcp * comm;
            let total_cost = tcp + tcom;
            this.setState({
                btotal_cost: total_cost.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            })
        }, 300);
    }



    onChangesCurrentPrice(e) {
        this.setState({
            scurrentprice: e.target.value
        })

        this.onChangesCalculator();
    }

    onChangesCommission(e) {
        this.setState({
            scommission: e.target.value
        })
        this.onChangesCalculator();
    }

    onChangesQuantity(e) {
        this.setState({
            squantity: e.target.value
        })
        this.onChangesCalculator();
    }

    onChangesCalculator() {
        setTimeout(() => {
            let comm = parseFloat(this.state.scommission ? this.state.scommission : 0) / 100,
                cp = parseFloat(this.state.scurrentprice ? this.state.scurrentprice : 0),
                qty = parseFloat(this.state.squantity ? this.state.squantity : 0);
            let tcp = cp * qty;
            let tcom = tcp * comm;
            let total_cost = tcp - tcom;
            this.setState({
                stotal_cost: total_cost.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            })
        }, 300);
    }

    render() {
        return (
            // <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin  stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h6 className="card-title">Financial Calculator</h6>
                                {/* <p className="card-description"> Here, you can create more documents </p> */}
                                <div className="nav mb-2 nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                    <a style={{padding: "10px 20px"}} className="nav-link active" id="v-pills-who-we-are-tab" data-bs-toggle="pill" href="#buy" role="tab" aria-selected="true" aria-controls="v-pills-who-we-are">Buy</a>
                                    <a style={{padding: "10px 20px"}} className="nav-link" id="v-pills-our-mission-tab" data-bs-toggle="pill" href="#sell" role="tab" aria-selected="false" aria-controls="v-pills-our-mission" >Sell</a>
                                </div>
                                <div className="tab-content" id="v-pills-tabContent">
                                    <form className="tab-pane fade show active forms-sample" id='buy' role="tabpanel" aria-labelledby="v-pills-who-we-are-tab">
                                        <Form.Group>
                                            <label htmlFor="title">Current Price</label>
                                            <Form.Control type="text" className="form-control" placeholder="Current Price" value={this.state.bcurrentprice} onChange={this.onChangebCurrentPrice} />
                                        </Form.Group>
                                        <Form.Group>
                                            <label htmlFor="title">Quantity</label>
                                            <Form.Control type="text" className="form-control" placeholder="Quantity" value={this.state.bquantity} onChange={this.onChangebQuantity} />
                                        </Form.Group>
                                        <Form.Group>
                                            <label htmlFor="title">Buy Commission (%)</label>
                                            <Form.Control type="text" className="form-control" placeholder="Buy Commission" value={this.state.bcommission} onChange={this.onChangebCommission} />
                                        </Form.Group>
                                        <Form.Group>
                                            <label htmlFor="title">Total Cost</label>
                                            <Form.Control type="text" className="form-control" placeholder="Total Cost" value={this.state.btotal_cost} readOnly />
                                        </Form.Group>
                                    </form>
                                    <form className="tab-pane fade show forms-sample" id='sell' role="tabpanel" aria-labelledby="v-pills-our-mission-tab">
                                        <Form.Group>
                                            <label htmlFor="title">Current Price</label>
                                            <Form.Control type="text" className="form-control" placeholder="Current Price" value={this.state.scurrentprice} onChange={this.onChangesCurrentPrice} />
                                        </Form.Group>
                                        <Form.Group>
                                            <label htmlFor="title">Quantity</label>
                                            <Form.Control type="text" className="form-control" placeholder="Quantity" value={this.state.squantity} onChange={this.onChangesQuantity} />
                                        </Form.Group>
                                        <Form.Group>
                                            <label htmlFor="title">Sell Commission (%)</label>
                                            <Form.Control type="text" className="form-control" placeholder="Sell Commission" value={this.state.scommission} onChange={this.onChangesCommission} />
                                        </Form.Group>
                                        <Form.Group>
                                            <label htmlFor="title">Total Cost</label>
                                            <Form.Control type="text" className="form-control" placeholder="Total Cost" value={this.state.stotal_cost} readOnly />
                                        </Form.Group>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            // </div>
        )
    }
}

export default Calculator;